module.exports = __webpack_public_path__ + "img/Hold.146cbe02.svg";